import LabContainer from './lab-container';

export default LabContainer;
